import * as tinyIntroActions from './tiny-intro-actions';
import {tinyIntroReducer} from './tiny-intro-reducer';
import * as tinyIntroSelectors from './tiny-intro-selector';

export const TinyIntroduction = {
    tinyIntroReducer,
    ...tinyIntroActions,
    ...tinyIntroSelectors,
} as const;

export type {TinyIntroState} from './tiny-intro-reducer';
